export const selfReferencingCanonical = (siteUrl: string, pathname: string) => {
  const trimmedPath = pathname === '/' ? '' : pathname.replace(/\/+$/, '')
  return `${siteUrl}${trimmedPath}`
}
